import React from 'react';
import PropTypes from 'prop-types';
import { useSwiper } from 'swiper/react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';

const Float = (props) => {
    const swiper = useSwiper();
    const { slideIndex, config } = props;

    const slides = config.filter((a) => a.isShow && a.id.match(/[0-9]/g));

    return (
        <div className={Style.float}>
            {config.find((a) => a.id === '2').isShow && (
                <div className={slideIndex === '2' ? Style.active : ''} onClick={() => swiper.slideTo(1)}>
                    会客厅
                </div>
            )}
            {config.find((a) => a.id === '3').isShow && (
                <div className={slideIndex === '3' ? Style.active : ''} onClick={() => swiper.slideTo(2)}>
                    新观点
                </div>
            )}
            {config.find((a) => a.id === '4').isShow && (
                <div className={slideIndex === '4' ? Style.active : ''} onClick={() => swiper.slideTo(3)}>
                    影像集
                </div>
            )}
        </div>
    );
};

Float.propTypes = {
    slideIndex: PropTypes.string,
    config: PropTypes.array,
};

export default errorBoundary(Float);
